import axios from "axios";

export const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("smartsn_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});
